import { Button } from "@kalodata/kds-design";
import { TestId } from "@shared/testIds";
import { Trans } from "react-i18next";

export interface PostVideoModalFooterProps {
  submitDisabled?: boolean;
  onCancel: () => void;
  onSubmit: () => void;
}

export const PostVideoModalFooter = ({ submitDisabled, onCancel, onSubmit }: PostVideoModalFooterProps) => {
  return (
    <div className="flex items-center justify-end gap-[8px] border-t border-kds-border p-[16px]">
      <Button variant="outline" size="lg" onClick={onCancel}>
        <Trans>Cancel</Trans>
      </Button>
      <Button
        className="bg-kds-dark-reverse text-kds-light-reverse hover:bg-(--palette-slate-11) hover:text-kds-light-reverse"
        size="lg"
        disabled={submitDisabled}
        data-testid={TestId.PostVideoModalSubmit}
        onClick={onSubmit}
      >
        <Trans>Submit</Trans>
      </Button>
    </div>
  );
};
